export default [
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/Messages/Message.vue'),
    meta: {
      title: 'Message'
    }
  }
]
